document.addEventListener('DOMContentLoaded', () => {

$(".fqa_item .question button").on("click", function (e) {
    e.stopPropagation();
    $(this).parents(".fqa_item").siblings().removeClass("answer_active");
    if ($(this).parents(".fqa_item").hasClass("answer_active")) {
      $(this).parents(".fqa_item").removeClass("answer_active");
    } else {
      $(this).parents(".fqa_item").addClass("answer_active");
    }
    $(this).parents(".fqa_item").siblings().find(".answer").slideUp();
    $(this).parent().siblings(".answer").slideToggle();
  });
  $(".fqa_item .question").on("click", function () {
    $(this).parents(".fqa_item").siblings().removeClass("answer_active");
    if ($(this).parents(".fqa_item").hasClass("answer_active")) {
      $(this).parents(".fqa_item").removeClass("answer_active");
    } else {
      $(this).parents(".fqa_item").addClass("answer_active");
    }
    $(this).parents(".fqa_item").siblings().find(".answer").slideUp();
    $(this).siblings(".answer").slideToggle();
  });

  // faq默认第一个展开
  $(".fqa_item:nth-child(1) .question").click();

  $(".bfcm23_banner1 .fixed_icon").on("click", function () {
    if ($(window).width() > 590) {
      $(this).siblings(".fixed_box").css({ left: "35px", opacity: "1" });
    } else {
      $(this).siblings(".fixed_box").css({ left: "0", opacity: "1" });
    }
    $(this).css({ transform: "translateX(100%)", opacity: "0" });
  });
});